import { URLRegex, getRuleErrorMessage } from "@/utils/formHelper";
import { qrListPickerValidations, qrNameValidation } from "./shared";
import { I_QREditorFormTemplate } from "@/data/types/pages";
import { TFunction } from "i18next";

export const videoValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "companyName",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("companyName", "maxLength", data),
        },
      },
    },
    {
      name: "title",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("title", "maxLength", data),
        },
      },
    },
    {
      name: "description",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("description", "maxLength", data),
        },
      },
    },
    {
      name: "videoContentUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("videoContentUrl", "pattern", data),
        },
      },
    },
    {
      name: "buttonText",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("buttonText", "maxLength", data),
        },
      },
    },
    {
      name: "buttonUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("buttonUrl", "pattern", data),
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
